import React from 'react';

export default function () {
  return (
    <svg viewBox="0 0 258 158" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <path
          d="M2.09 3.79L1.075 2.777.73 3.12l1.36 1.36 2.92-2.92-.343-.342z"
          id="a"
        />
        <path
          d="M2.09 3.79L1.075 2.777.73 3.12l1.36 1.36 2.92-2.92-.343-.342z"
          id="c"
        />
        <path
          d="M4.623 1.56l-.343-.343-1.36 1.36-1.36-1.36-.343.343 1.36 1.36-1.36 1.36.343.343 1.36-1.36 1.36 1.36.343-.343-1.36-1.36z"
          id="e"
        />
        <path
          d="M2.09 3.79L1.075 2.777.73 3.12l1.36 1.36 2.92-2.92-.343-.342z"
          id="g"
        />
        <path
          d="M17.032 2.839c-7.835 0-14.193 6.358-14.193 14.193 0 7.834 6.358 14.193 14.193 14.193 7.834 0 14.193-6.359 14.193-14.193 0-7.835-6.359-14.193-14.193-14.193zm1.419 21.29h-2.839v-2.84h2.839v2.84zm0-5.678h-2.839V9.935h2.839v8.516z"
          id="i"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <ellipse
          cx="129.197"
          cy="149.222"
          fill="#F0F1F1"
          rx="59.124"
          ry="8.778"
        />
        <g fill="#BABFC0">
          <g transform="rotate(-180 98.175 34.014)">
            <ellipse cx="2.92" cy="38.037" rx="2.92" ry="2.926" />
            <path d="M13.148 0h6.56v8.778h-6.56a4.389 4.389 0 0 1 0-8.778zM11.685 35.111h8.023v5.852h-8.023a2.926 2.926 0 1 1 0-5.852z" />
          </g>
          <g transform="translate(0 27.065)">
            <ellipse cx="2.92" cy="2.926" rx="2.92" ry="2.926" />
            <ellipse cx="64.964" cy="64.37" rx="2.92" ry="2.926" />
            <ellipse cx="43.796" cy="20.481" rx="2.92" ry="2.926" />
            <path d="M20.444 0h61.308v5.852H20.444a2.926 2.926 0 1 1 0-5.852zM75.192 26.333h6.56v8.778h-6.56a4.389 4.389 0 0 1 0-8.778zM73.729 61.444h8.023v5.852h-8.023a2.926 2.926 0 0 1 0-5.852zM58.394 35.111h23.358v17.556H58.394a8.76 8.76 0 0 1-8.759-8.76v-.037a8.76 8.76 0 0 1 8.76-8.759z" />
          </g>
        </g>
        <g transform="translate(81.752)">
          <rect fill="#BABFC0" height="122.889" rx="5.839" width="94.891" />
          <rect
            fill="#FFF"
            height="111.185"
            rx="2.92"
            width="83.212"
            x="5.839"
            y="5.852"
          />
          <path d="M29.197 99.481h48.175v5.852H29.197z" fill="#F0F1F1" />
          <g transform="translate(17.518 99.481)">
            <path d="M0 0h5.84v5.84H0z" />
            <mask fill="#fff" id="b">
              <use xlinkHref="#a" />
            </mask>
            <use fill="#000" fillRule="nonzero" xlinkHref="#a" />
            <g fill="#005B86" mask="url(#b)">
              <path d="M0 0h6.002v6.006H0z" />
            </g>
          </g>
          <path d="M29.197 87.777h48.175v5.852H29.197z" fill="#F0F1F1" />
          <g transform="translate(17.518 87.778)">
            <path d="M0 0h5.84v5.84H0z" />
            <mask fill="#fff" id="d">
              <use xlinkHref="#c" />
            </mask>
            <use fill="#000" fillRule="nonzero" xlinkHref="#c" />
            <g fill="#005B86" mask="url(#d)">
              <path d="M0 0h6.002v6.006H0z" />
            </g>
          </g>
          <path d="M29.197 76.074h48.175v5.852H29.197z" fill="#F0F1F1" />
          <g transform="translate(17.518 76.074)">
            <path d="M0 0h5.84v5.84H0z" />
            <mask fill="#fff" id="f">
              <use xlinkHref="#e" />
            </mask>
            <use fill="#193159" fillRule="nonzero" xlinkHref="#e" />
            <g fill="#FA6428" mask="url(#f)">
              <path d="M0 0h6.002v6.006H0z" />
            </g>
          </g>
          <path d="M29.197 64.37h48.175v5.852H29.197z" fill="#F0F1F1" />
          <g transform="translate(17.518 64.37)">
            <path d="M0 0h5.84v5.84H0z" />
            <mask fill="#fff" id="h">
              <use xlinkHref="#g" />
            </mask>
            <use fill="#000" fillRule="nonzero" xlinkHref="#g" />
            <g fill="#005B86" mask="url(#h)">
              <path d="M0 0h6.002v6.006H0z" />
            </g>
          </g>
          <g transform="translate(29.927 17.556)">
            <path d="M0 0h34.063v34.063H0z" />
            <mask fill="#fff" id="j">
              <use xlinkHref="#i" />
            </mask>
            <use
              fill="#FFF"
              fillRule="nonzero"
              transform="matrix(1 0 0 -1 0 34.063)"
              xlinkHref="#i"
            />
            <g fill="#FA6428" mask="url(#j)">
              <path d="M0 0h34.009v34.035H0z" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
